import { render, staticRenderFns } from "./UploadDraftAppScreenshots.vue?vue&type=template&id=57a41b48"
import script from "./UploadDraftAppScreenshots.vue?vue&type=script&lang=js"
export * from "./UploadDraftAppScreenshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports